<template>
  <div class="main-head" :class="{ mobile: mobile }">
    <div class="selector-left">
      <div class="filter-status-area" v-if="showFilterStatus">
        <el-select v-model="filterStatus" filterable size="small" data-testid="filterByStatus">
          <el-option
            v-for="(item, index) in filterStatusOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <InfoPopover popoverWidth="300" placement="bottom">
          <template v-slot:popoverContent>
            <div class="popover-info-content">
              <ol type="1">
                <li v-for="(info, index) in infoContents" :key="index">{{ info }}</li>
              </ol>
            </div>
          </template>
        </InfoPopover>
      </div>
      <el-select
        v-if="showFilterStages"
        v-model="filterStages"
        class="filter-stage"
        filterable
        size="small"
        data-testid="filterByStages"
      >
        <el-option v-for="(item, index) in filterStagesOptions" :key="index" :label="item.label" :value="item.value" />
      </el-select>

      <div class="filter-session-area" v-if="showFilterSession">
        <el-select
          v-model="filterSession"
          class="filter-session"
          filterable
          size="small"
          data-testid="filterBySessions"
        >
          <el-option
            v-for="(item, index) in filterSessionOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <InfoPopover popoverWidth="280" placement="bottom">
          <template v-slot:popoverContent>
            <div class="popover-info-content">
              <ol type="1">
                <li v-for="(info, index) in paymentStatusInfoContents" :key="index">
                  {{ info }}
                </li>
              </ol>
            </div>
          </template>
        </InfoPopover>
      </div>
    </div>

    <div class="selector-right">
      <div class="create-account-button" @click="createNewAccount" data-testid="createNewAccount">
        <div class="create-account-button-content">
          <span class="el-icon-plus" />
          <span>{{ $t('propTrade.button.createNewAccount') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ACCOUNT_STAGE, ACCOUNT_STATUS, SESSION_STATUS, PAYMENT_STATUS } from '@/constants/propTrade';
import InfoPopover from '@/components/propTrading/components/common/InfoPopover.vue';

export default {
  name: 'PropTradingDashboardSearchbar',
  props: {
    excludeStatusOption: {
      type: Array,
      default: () => []
    },
    excludeStagesOption: {
      type: Array,
      default: () => []
    },
    showFilterStatus: {
      type: Boolean,
      default: true
    },
    showFilterStages: {
      type: Boolean,
      default: true
    },
    showFilterSession: {
      type: Boolean,
      default: false
    },
    containerWidth: {
      type: Number | String,
      default: 0
    }
  },
  components: { InfoPopover },
  data() {
    return {
      filterStatus: ACCOUNT_STATUS.ALL,
      filterStages: ACCOUNT_STAGE.ALL,
      filterSession: PAYMENT_STATUS.ALL,
      viewType: 'card' // type of data performance, card or list type
    };
  },
  computed: {
    infoContents() {
      let res = [];
      Array.from({ length: 6 }, (item, index) => {
        res.push(this.$t(`propTrade.dashboard.accountStatusInfo.${index + 1}`));
      });
      return res;
    },
    paymentStatusInfoContents() {
      let res = [];
      Array.from({ length: 3 }, (item, index) => {
        res.push(this.$t(`propTrade.dashboard.PaymentStatusInfo.${index + 1}`));
      });
      return res;
    },
    filterStatusOptions() {
      const defaultOptions = [
        {
          label: this.$t(`propTrade.statusContext.allStatus`),
          value: ACCOUNT_STATUS.ALL
        },
        {
          label: this.$t(`propTrade.statusContext.active`),
          value: ACCOUNT_STATUS.ACTIVE
        },
        {
          label: this.$t(`propTrade.statusContext.payoutPending`),
          value: ACCOUNT_STATUS.PAYOUT_PENDING
        },
        {
          label: this.$t(`propTrade.statusContext.verifying`),
          value: ACCOUNT_STATUS.VERIFYING
        },
        {
          label: this.$t(`propTrade.statusContext.passed`),
          value: ACCOUNT_STATUS.PASSED
        },
        {
          label: this.$t(`propTrade.statusContext.failed`),
          value: ACCOUNT_STATUS.FAILED
        },
        {
          label: this.$t(`propTrade.statusContext.processing`),
          value: ACCOUNT_STATUS.PROCESSING
        }
      ];

      return this.excludeStatusOption.length
        ? defaultOptions.filter(item => !this.excludeStatusOption.includes(item))
        : defaultOptions;
    },
    filterStagesOptions() {
      const defaultOptions = [
        {
          label: this.$t(`propTrade.accountStageContext.allStages`),
          value: ACCOUNT_STAGE.ALL
        },
        {
          label: this.$t(`propTrade.accountStageContext.liveTrading`),
          value: ACCOUNT_STAGE.LIVE_TRADING
        },
        {
          label: this.$t(`propTrade.accountStageContext.liveTradingPlus`),
          value: ACCOUNT_STAGE.LIVE_TRADING_PLUS
        },
        {
          label: this.$t(`propTrade.accountStageContext.evaluation`),
          value: ACCOUNT_STAGE.EVALUATION
        },
        {
          label: this.$t(`propTrade.accountStageContext.evaluationPlus`),
          value: ACCOUNT_STAGE.EVALUATION_PLUS
        },
        {
          label: this.$t(`propTrade.accountStageContext.challenge`),
          value: ACCOUNT_STAGE.CHALLENGE
        },
        {
          label: this.$t(`propTrade.accountStageContext.challengePlus`),
          value: ACCOUNT_STAGE.CHALLENGE_PLUS
        }
      ];

      return this.excludeStagesOption.length
        ? defaultOptions.filter(item => !this.excludeStagesOption.includes(item))
        : defaultOptions;
    },
    filterSessionOptions() {
      const defaultOptions = [
        {
          label: this.$t(`propTrade.sessionContext.all`),
          value: PAYMENT_STATUS.ALL
        },
        {
          label: this.$t(`propTrade.sessionContext.Processing`),
          value: PAYMENT_STATUS.PROCESSING
        },
        // {
        //   label: this.$t(`propTrade.sessionContext.submitted`),
        //   value: PAYMENT_STATUS.SUBMITTED
        // },
        // {
        //   label: this.$t(`propTrade.sessionContext.expired`),
        //   value: PAYMENT_STATUS.EXPIRED
        // },
        // {
        //   label: this.$t(`propTrade.sessionContext.mismatch`),
        //   value: PAYMENT_STATUS.MISMATCHED
        // },
        {
          label: this.$t(`propTrade.sessionContext.success`),
          value: PAYMENT_STATUS.SUCCESS
        },
        {
          label: this.$t(`propTrade.sessionContext.fail`),
          value: PAYMENT_STATUS.FAILED
        }
      ];

      return defaultOptions;
    },
    mobile() {
      return this.containerWidth <= 700;
    },
    calPopoverWidth() {
      return this.mobile ? 300 : 385;
    },
    calPopoverPlacement() {
      return this.mobile ? 'bottom' : 'right-start';
    }
  },
  watch: {
    filterStatus: {
      immediate: true,
      handler(newValue) {
        this.$emit('statusChange', newValue);
      }
    },
    filterStages: {
      immediate: true,
      handler(newValue) {
        this.$emit('stagesChange', newValue);
      }
    },
    filterSession: {
      immediate: true,
      handler(newValue) {
        this.$emit('sessionChange', newValue);
      }
    }
  },
  methods: {
    async createNewAccount() {
      await this.$router.push({ name: 'propTradingCreateAccount' }).catch(() => {});
    },
    onViewTypeChange(val) {
      this.$emit('update:viewType', val);
    }
  }
};
</script>

<style lang="scss">
.popover-info-content {
  @include rtl-sass-prop(padding-left, padding-right, 16px);
  ol {
    list-style: decimal !important;
    @include rtl-sass-prop(margin-left, margin-right, 8px);
  }
  li {
    list-style: decimal !important;
    @include rtl-sass-prop(padding-left, padding-right, 8px);
    @include rtl-sass-value(text-align, left, right);
    margin-bottom: 6px;
    &:nth-last-child(1) {
      margin-bottom: 0px;
    }
  }
}
</style>

<style lang="scss" scoped>
/deep/.el-select {
  max-width: 280px;
  input {
    &::placeholder {
    }
  }
  .el-input__inner {
    background-color: #fff;
    color: #32323266;
    font-size: 14px;
  }
}

.main-head {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 15px;

  .selector-left {
    width: 100%;
    gap: 24px;
    display: flex;
    align-items: center;

    .filter-status-area,
    .filter-session-area {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 12px;
    }
    .filter-stage {
      width: 100%;
    }

    .el-icon-warning {
      cursor: pointer;
    }
  }

  .selector-right {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 15px;

    .create-account-button {
      background-color: $white;

      width: fit-content;
      height: 32px;
      display: flex;
      justify-content: center;
      border: 1px solid $primary-blue;
      border-radius: 36px;
      padding: 6px 16px;
      background-color: transparent;
      cursor: pointer;

      span {
        font-size: 14px;
        line-height: 18px;
        color: $primary-blue;
      }
      &:hover {
        color: rgba($primary-alt, 0.1);
      }
      .el-icon-plus {
        font-weight: 600;
        @include rtl-sass-prop(padding-right, padding-left, 5px);
      }

      &-content {
        display: flex;
        align-items: center;
      }
    }

    .view-switcher {
      display: flex;
      align-items: center;
      width: 72px;
      & /deep/ .el-radio-button {
        .el-radio-button__inner {
          padding: 0;
          width: 36px;
          height: 28px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: $white;
          border: none;
          .rb-btn {
            display: inline-block;
            width: 24px;
            height: 24px;
          }
          &:hover {
            border-color: rgba(0, 0, 0, 0.2);
          }
        }
        &.is-active {
          .el-radio-button__inner {
            background-color: rgba($primary-alt, 0.2);
            border-color: rgba($primary-alt, 0) !important;
            box-shadow: none;
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  /deep/.el-select {
    max-width: auto;
  }
  .main-head {
    flex-direction: column-reverse;

    .selector-left {
      gap: 12px;
    }

    .selector-right {
      width: 100%;
      justify-content: flex-start;

      .create-account-button {
        width: 100%;
        height: auto;
      }
    }
  }
}
</style>
